// extracted by mini-css-extract-plugin
export var modal = "_fk-0";